import React from "react";
import { CONTENT, STATIC_URLS } from "consts";
import { connect } from "react-redux";
import { config } from "config";

import { formatBitesPerSec, objectToArray, outlineFocus } from "utils";
function BackupPlanAdvanceSettings(props) {
  const speedTabs = [
    { key: "Mbps", value: "Mbps" },
    { key: "Kbps", value: "Kbps" }
  ];

  const [currentTab, setCurrentTab] = React.useState(
    formatBitesPerSec(props.planSettings.performance.speed.value).split(" ")[1]
  );

  function toggleSpeedUnit(unit) {
    setCurrentTab(unit);
    let tempSpeed = 0;
    let tempUnit = formatBitesPerSec(
      props.planSettings.performance.speed.value
    ).split(" ")[1];
    if (tempUnit === "Mbps") {
      tempSpeed = props.planSettings.performance.speed.value / 1000 / 1000;
    } else {
      tempSpeed = props.planSettings.performance.speed.value / 1000;
    }
    if (unit === "Mbps") {
      tempSpeed = tempSpeed * 1000 * 1000;
    } else {
      tempSpeed = tempSpeed * 1000;
    }
    props.setPlanSettings({
      ...props.planSettings,
      performance: {
        ...props.planSettings.performance,
        speed: {
          ...props.planSettings.performance.speed,
          value: +tempSpeed
        }
      }
    });
  }
  return (
    <div className="plan_cont_blk">
      <div className="createBkp-cont">
        <div className="summary_wrap_body">
          <div className="advance_cleanup">
            <div className="sub_title">
              <p>Cleanup</p>
            </div>
            <div className="cleanup_item">
              <div className="checkbox_wrapper just_flex">
                <div className="just_flex">
                  <p>
                    {CONTENT.backupSettings.advance.cleanup.automatically.part1}
                  </p>
                  <div
                    className="custom_number transparent_layer_wrap transparent_layer_dv layer_active"
                    style={{ margin: "0 10px" }}
                  >
                    <input
                      min={1}
                      type="number"
                      className="input_number"
                      onChange={e =>
                        props.setPlanSettings({
                          ...props.planSettings,
                          cleanup: {
                            ...props.planSettings.cleanup,
                            scheduleCount:
                              +e.target.value === 0
                                ? 1
                                : +e.target.value > 999
                                ? parseInt(+e.target.value / 10)
                                : +e.target.value
                          }
                        })
                      }
                      value={props.planSettings.cleanup.scheduleCount}
                    />
                  </div>
                  <p>
                    {CONTENT.backupSettings.advance.cleanup.automatically.part2}
                  </p>
                </div>
              </div>
            </div>
            <div className="cleanup_item last_child_bottom">
              <div className="checkbox_wrapper just_flex">
                <div
                  className="check"
                  onChange={() =>
                    props.setPlanSettings({
                      ...props.planSettings,
                      cleanup: {
                        ...props.planSettings.cleanup,
                        months: {
                          ...props.planSettings.cleanup.months,
                          checked: !props.planSettings.cleanup.months.checked
                        }
                      }
                    })
                  }
                >
                  {props.planSettings.cleanup.months.checked && (
                    <input
                      type="checkbox"
                      className={
                        "input_checkbox" +
                        (props.planSettings.cleanup.months.checked &&
                        window.browserName === "ie"
                          ? " ie_checked"
                          : "")
                      }
                      id="advance_settings_22"
                      checked
                      onFocus={() => {
                        outlineFocus("advance_settings_22_label", 1);
                      }}
                      onBlur={() => {
                        outlineFocus("advance_settings_22_label", 0);
                      }}
                    />
                  )}
                  {!props.planSettings.cleanup.months.checked && (
                    <input
                      type="checkbox"
                      className={
                        "input_checkbox" +
                        (props.planSettings.cleanup.months.checked &&
                        window.browserName === "ie"
                          ? " ie_checked"
                          : "")
                      }
                      id="advance_settings_22"
                      onFocus={() => {
                        outlineFocus("advance_settings_22_label", 1);
                      }}
                      onBlur={() => {
                        outlineFocus("advance_settings_22_label", 0);
                      }}
                    />
                  )}
                  <label
                    htmlFor="advance_settings_22"
                    id="advance_settings_22_label"
                  ></label>
                </div>
                <div className="just_flex checkbox_p">
                  <p
                    onClick={e =>
                      props.setPlanSettings({
                        ...props.planSettings,
                        cleanup: {
                          ...props.planSettings.cleanup,
                          months: {
                            ...props.planSettings.cleanup.months,
                            checked: !props.planSettings.cleanup.months.checked
                          }
                        }
                      })
                    }
                  >
                    {CONTENT.backupSettings.advance.cleanup.delete.part1}
                  </p>
                  <div
                    className={[
                      "custom_number transparent_layer_wrap transparent_layer_dv",
                      props.planSettings.cleanup.months.checked
                        ? "layer_active"
                        : ""
                    ].join(" ")}
                    style={{ margin: "0 10px" }}
                  >
                    {!props.planSettings.cleanup.months.checked && (
                      <div class="transparent_layer"></div>
                    )}
                    <input
                      min={1}
                      type="number"
                      className="input_number"
                      value={props.planSettings.cleanup.months.value}
                      onChange={e =>
                        props.setPlanSettings({
                          ...props.planSettings,
                          cleanup: {
                            ...props.planSettings.cleanup,
                            months: {
                              ...props.planSettings.cleanup.months,
                              value:
                                +e.target.value === 0
                                  ? 1
                                  : +e.target.value > 99
                                  ? parseInt(+e.target.value / 10)
                                  : +e.target.value
                            }
                          }
                        })
                      }
                    />
                  </div>
                  <p>{CONTENT.backupSettings.advance.cleanup.delete.part2}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="advance_performance">
            <div className="sub_title">
              <p>Performance</p>
            </div>
            <div className="performance_item flex_align">
              <p>
                {
                  CONTENT.backupSettings.advance.performance.backupPriority
                    .part1
                }{" "}
              </p>
              <div className="main_select" style={{ margin: "0 10px" }}>
                <select
                  value={props.planSettings.performance.priority}
                  onChange={e =>
                    props.setPlanSettings({
                      ...props.planSettings,
                      performance: {
                        ...props.planSettings.performance,
                        priority: +e.target.value
                      }
                    })
                  }
                >
                  {objectToArray(props.performancePriorityEnums.props).map(
                    (val, i) => (
                      <option
                        value={props.performancePriorityEnums[val.key]}
                        key={i}
                      >
                        {val.name.charAt(0).toUpperCase() + val.name.slice(1)}
                      </option>
                    )
                  )}
                </select>
              </div>
            </div>
            <div className="performance_item">
              <p>
                {CONTENT.backupSettings.advance.performance.networkSpeed.part1}{" "}
              </p>
              <div className="performance_limit flex_align mob_flex_col">
                <div className="limit_item">
                  <label className="radio_container">
                    <input
                      type="radio"
                      className="input_radio"
                      name="limit_performance_radio1"
                      defaultChecked={
                        !props.planSettings.performance.speed.limit
                      }
                      onFocus={() => {
                        outlineFocus("radio_checkmark_limit", 1);
                      }}
                      onBlur={() => {
                        outlineFocus("radio_checkmark_limit", 0);
                      }}
                      onClick={() =>
                        props.setPlanSettings({
                          ...props.planSettings,
                          performance: {
                            ...props.planSettings.performance,
                            speed: {
                              ...props.planSettings.performance.speed,
                              limit: 0
                            }
                          }
                        })
                      }
                    />
                    <span
                      className="radio_checkmark"
                      id="radio_checkmark_limit"
                    ></span>{" "}
                    <span>Don't Limit</span>{" "}
                  </label>
                </div>
                <div className="limit_item flex_align">
                  <label className="radio_container">
                    <input
                      type="radio"
                      className="input_radio"
                      name="limit_performance_radio1"
                      defaultChecked={
                        props.planSettings.performance.speed.limit
                      }
                      onClick={() =>
                        props.setPlanSettings({
                          ...props.planSettings,
                          performance: {
                            ...props.planSettings.performance,
                            speed: {
                              ...props.planSettings.performance.speed,
                              limit: 1
                            }
                          }
                        })
                      }
                    />
                    <span className="radio_checkmark"></span>{" "}
                    <span>Limit To</span>{" "}
                  </label>
                  <div
                    className={[
                      "limit_speed transparent_layer_wrap transparent_layer_limit",
                      !props.planSettings.performance.speed.limit ||
                      props.planSettings.performance.speed.limit === 0
                        ? ""
                        : "layer_active"
                    ].join(" ")}
                  >
                    <div className="transparent_layer"></div>
                    <input
                      type="number"
                      className="input_number"
                      min="1"
                      value={
                        formatBitesPerSec(
                          props.planSettings.performance.speed.value
                        ).split(" ")[0]
                      }
                      onChange={e =>
                        props.setPlanSettings({
                          ...props.planSettings,
                          performance: {
                            ...props.planSettings.performance,
                            speed: {
                              ...props.planSettings.performance.speed,
                              value:
                                currentTab === "Mbps"
                                  ? (+e.target.value === 0
                                      ? 1
                                      : +e.target.value > 999
                                      ? parseInt(+e.target.value / 10)
                                      : +e.target.value) *
                                    1000 *
                                    1000
                                  : (+e.target.value === 0
                                      ? 1
                                      : +e.target.value) * 1000
                            }
                          }
                        })
                      }
                    />
                    <div className="limit_speed_tail">
                      <div className="main_select">
                        <select
                          value={currentTab}
                          onChange={e => toggleSpeedUnit(e.target.value)}
                        >
                          {speedTabs.map(val => (
                            <option value={val.key} key={val.key}>
                              {val.value}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="advance_cleanup crc_settings">
            <div className="sub_title">
              <p>Error Handling </p>
            </div>
            <div className="cleanup_item last_child_bottom">
              <div className="checkbox_wrapper just_flex">
                <div className="check">
                  <input
                    type="checkbox"
                    defaultChecked={
                      props.planSettings.performance.ignoreBadSectors === 1
                    }
                    checked={
                      props.planSettings.performance.ignoreBadSectors === 1
                    }
                    onChange={e =>
                      props.setPlanSettings({
                        ...props.planSettings,
                        performance: {
                          ...props.planSettings.performance,
                          ignoreBadSectors: e.target.checked ? 1 : 0
                        }
                      })
                    }
                    className="input_checkbox"
                    id="delete_versions_2"
                  />
                  <label
                    for="delete_versions_2"
                    id="delete_versions_2_label"
                  ></label>
                </div>
                <div
                  className="just_flex checkbox_p "
                  onClick={() => {
                    props.setPlanSettings({
                      ...props.planSettings,
                      performance: {
                        ...props.planSettings.performance,
                        ignoreBadSectors:
                          props.planSettings.performance.ignoreBadSectors === 1
                            ? 0
                            : 1
                      }
                    });
                  }}
                >
                  <p>{CONTENT.backupSettings.advance.skipDiskErr.checkLabel}</p>
                  <span></span>
                </div>
              </div>
              <div class="next_schedule_msg">
                <p>
                  <strong>Note: </strong>
                  {CONTENT.backupSettings.advance.skipDiskErr.checkNote}{" "}
                  <a
                    href={
                      STATIC_URLS.diskFaq[
                        props?.origin === "idrive"
                          ? "idrive"
                          : config.APP_INSTANCE
                      ]
                    }
                    target="_blank"
                  >
                    Know more.
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    performancePriorityEnums: state.common.enums.PerformancePriority,
    origin: state.account.origin
  };
}

export default connect(mapStateToProps)(BackupPlanAdvanceSettings);
